import { render, staticRenderFns } from "./KBFiles.vue?vue&type=template&id=8b13d212&scoped=true"
import script from "./KBFiles.vue?vue&type=script&lang=js"
export * from "./KBFiles.vue?vue&type=script&lang=js"
import style0 from "./KBFiles.vue?vue&type=style&index=0&id=8b13d212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b13d212",
  null
  
)

export default component.exports